import { render } from "./VariablesPage.vue?vue&type=template&id=3066837e"
import script from "./VariablesPage.vue?vue&type=script&lang=js"
export * from "./VariablesPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__